var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEclLogoSvgWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "820px",
    height: "444px",
    viewBox: "0 0 820 444",
    enableBackground: "new 0 0 820 444",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x23_ffffffff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x23_050409ff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M249.229,29.147c42.655-13.865,52.311,56.371,59.496,85.308c5.146,30.407,8.777,56.477-8.765,77.892 c-14.244,22.131-47.041,30.735-70.21,16.196c-30.538-22.876-36.542-64.776-29.861-100.169 C202.808,78.719,217.484,41.722,249.229,29.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M500.491,213.073c71.627-3.396,138.092,18.356,194.324,56.992 c50.564,35.632,100.832,83.769,122.234,148.773c-28.639-11.282-34.043-15.159-62.311-24.7c-70.506-29.807-147.482-47.573-226-61.89 c-31.379-30.159-71.557-55.336-115.428-72.554c-17.475-6.858-28.067-8.636-50.323-16.13 C404.2,222.14,452.802,211.629,500.491,213.073z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M256.273,219.993c17.921-6.302,15.03,15.549,13.767,26.469c-1.545,13.009,18.046,5.247,27.926,7.396 c61.216-1.447,122.615,15.436,168.393,53.72c24.338,16.917-9.318,13.417-18.467,14.512 C293.786,322.987,138.221,350.774,2.95,425.714c14.808-48.827,36.642-67.123,65.608-94.349 c51.911-42.705,168.28-74.879,183.494-75.878C256.426,253.389,246.787,227.487,256.273,219.993z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclLogoSvgWhite);
export default __webpack_public_path__ + "static/media/ecl-logo-svg-white.fcd4407d8316cf53166a707732ffe260.svg";
export { ForwardRef as ReactComponent };